import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorks from './components/HowItWorks';
import BlogPreview from './components/BlogPreview';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';

const siteUrl = import.meta.env.VITE_SITE_URL;

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'itaobuyspreadsheet',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
      description: 'A structured product sourcing spreadsheet system designed to simplify buying from China platforms such as Taobao and 1688.',
    },
    {
      '@type': 'WebPage',
      name: 'itaobuyspreadsheet — Smart China Sourcing & Product Comparison Tool',
      description: 'Discover itaobuyspreadsheet — the powerful sourcing spreadsheet system for China products. Compare verified suppliers, reduce sourcing costs by up to 70%, and streamline your Taobao & 1688 buying process.',
      url: siteUrl,
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is itaobuyspreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'itaobuyspreadsheet is a structured sourcing system that helps users find and compare China products efficiently. It organizes verified product listings from Taobao, 1688, and other Chinese platforms into an easy-to-navigate spreadsheet format.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is itaobuyspreadsheet safe to use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, itaobuyspreadsheet only provides structured supplier data and verified listings. It does not handle payments or personal financial information. The platform focuses on helping you make informed sourcing decisions with pre-vetted supplier information.',
          },
        },
        {
          '@type': 'Question',
          name: 'Who should use itaobuyspreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'itaobuyspreadsheet is ideal for dropshippers, Amazon sellers, Shopify store owners, wholesale buyers, and anyone sourcing products from China who wants to save time, reduce risk, and find better supplier pricing.',
          },
        },
        {
          '@type': 'Question',
          name: 'How often is the product data updated?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The product database within itaobuyspreadsheet receives regular updates to ensure listings, pricing, and supplier information remain current. This means you are always working with fresh, actionable sourcing data.',
          },
        },
        {
          '@type': 'Question',
          name: 'How much can I save using itaobuyspreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Users of itaobuyspreadsheet typically report saving between 30% and 70% on sourcing costs. These savings come from better supplier price comparison, avoiding middleman markups, and reducing costly purchasing mistakes caused by insufficient research.',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <title>itaobuyspreadsheet | Smart China Sourcing &amp; Product Comparison Tool</title>
      <meta name="description" content="Discover itaobuyspreadsheet — the powerful sourcing spreadsheet system for China products. Compare verified suppliers, reduce sourcing costs by up to 70%, and streamline your Taobao &amp; 1688 buying process. Built for dropshippers, resellers, Amazon &amp; Shopify sellers worldwide." />
      <meta name="keywords" content="itaobuyspreadsheet, china sourcing spreadsheet, taobao spreadsheet tool, buying agent spreadsheet, product sourcing sheet, verified supplier spreadsheet" />
      <link rel="canonical" href={siteUrl} />
      <SchemaOrg data={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />

        <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
          <CategoryDropdown />
        </section>

        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <HowItWorks />
        <BlogPreview />
        <TestimonialSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}